import { render } from "./CardComponent.vue?vue&type=template&id=4b3b4d82&scoped=true"
import script from "./CardComponent.vue?vue&type=script&lang=js"
export * from "./CardComponent.vue?vue&type=script&lang=js"

import "./CardComponent.vue?vue&type=style&index=0&id=4b3b4d82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3b4d82"]])

export default __exports__